import dayjs from 'dayjs';
import React from 'react';

export const MarketColumns = [
  {
    header: 'Dataset',
    accessorKey: 'Dataset',
    size: 100,
    enableColumnFilter: false,
    enableSorting: false
  },
  {
    header: 'Data Provider',
    accessorKey: 'dataProvider',
    size: 100,
    enableColumnFilter: false,
    enableSorting: false
  },
  {
    header: 'Data Provider Type',
    accessorKey: 'DirectIndirect',
    minWidth: 160,
    enableColumnFilter: false,
    enableSorting: false
  },
  {
    header: 'Country',
    accessorKey: 'country',
    size: 100,
    enableColumnFilter: false,
    enableSorting: false
  },
  // {
  //   header: 'External Category',
  //   accessorKey: 'category',
  //   size: 100,
  //   enableColumnFilter: false,
  //   enableSorting: false
  // },
  // {
  //   header: 'Cell Database',
  //   accessorKey: 'data',
  //   minWidth: 300,
  //   enableColumnFilter: false,
  //   enableSorting: false,
  //   Cell: (cell: any) => {
  //     return (
  //       <div>
  //         {cell.row.original?.fileName} {cell.row.original?.category}
  //       </div>
  //     );
  //   }
  // },
  // {
  //   header: 'Filename',
  //   accessorKey: 'fileName',
  //   size: 100,
  //   enableColumnFilter: false,
  //   enableSorting: false
  // },
  // {
  //   header: 'Loaded On',
  //   accessorKey: 'createdOn',
  //   minWidth: 180,
  //   enableColumnFilter: false,
  //   Cell: ({ value }: any) => dayjs(value).format('DD/MMM/YY hh:mm a')
  // },
  // {
  //   header: 'Records',
  //   minWidth: 300,
  //   columns: [
  //     {
  //       header: 'Mapped',
  //       accessorKey: 'mappedRecordCount',
  //       size: 100,
  //       enableColumnFilter: false,
  //       enableSorting: true
  //     },
  //     {
  //       header: 'Unprocessed',
  //       accessorKey: 'unmappedRecordCount',
  //       size: 100,
  //       enableColumnFilter: false,
  //       enableSorting: true
  //     },
  //     {
  //       header: 'Mapped by SME',
  //       accessorKey: 'recordsmappedBySME',
  //       size: 100,
  //       enableColumnFilter: false,
  //       enableSorting: true
  //     },
  //     {
  //       header: 'Total',
  //       accessorKey: 'total',
  //       size: 100,
  //       enableColumnFilter: false,
  //       enableSorting: true
  //     },
  //     {
  //       header: 'Success Status(%)',
  //       size: 100,
  //       accessorKey: 'successStatus',
  //       enableColumnFilter: false,
  //       enableSorting: false,
  //       Cell: (cell: any) => {
  //         const original = cell.row.original;
  //         const mappedCount = original.mappedRecordCount ?? 0;
  //         const total = original.total ?? 0;
  //         const successStatus = ((mappedCount / total) * 100).toFixed(2);
  //         return <div>{successStatus}</div>;
  //       }
  //     }
  //   ]
  // }
];
